import React from "react";
import Icons from "../../../../../../components/UI/Icons";
import { isSet } from "../../../../../../utils/commonUtils";

const SendMessageButton = ({
  name,
  formData,
  resultActionFieldName,
  resultActionOptions = [],
  sendMessageClickHandler,
  ...props
}) => {
  const value = isSet(formData?.[name], "");
  const resultActionValue = isSet(formData?.[resultActionFieldName], "");
  const taskTitleLabel =
    resultActionOptions.find((o) => String(o.value) === String(resultActionValue))?.label || resultActionValue || "";

  const notesEmpty = !String(value || "").trim();
  const noActionNeeded = String(resultActionValue || "") === "no_action_needed";
  const isSendDisabled = notesEmpty || noActionNeeded;

  const handleSendMessageClick = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (isSendDisabled || !sendMessageClickHandler) return;
    sendMessageClickHandler(taskTitleLabel, value || "");
  };

  return (
    <button
      type="button"
      className={`btn btn-sm d-inline-flex align-items-center gap-2 px-3 ${isSendDisabled ? "btn-secondary opacity-75" : "btn-primary"}`}
      title={isSendDisabled ? (notesEmpty ? "Add notes to send a message" : "Select an action other than No Action Needed to send") : "Send Message"}
      onClick={(e) => handleSendMessageClick(e)}
      aria-label="Send Message"
      disabled={isSendDisabled}
    >
      <Icons type="ChatSquareTextFill" />
      <span>Send Message</span>
    </button>
  );
};

export default SendMessageButton;
